// extracted by mini-css-extract-plugin
export var bounce = "_k2-1";
export var generatingText = "_k2-6";
export var lightning = "_k2-4";
export var popup = "_k2-5";
export var progressBar = "_k2-7";
export var progressFill = "_k2-8";
export var progressShimmer = "_k2-9";
export var progressText = "_k2-a";
export var shimmer = "_k2-3";
export var uploadIcon = "_k2-0";
export var uploadingText = "_k2-2";